import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HLSPlaybackMode } from '@aws-sdk/client-kinesis-video-archived-media';
import { getNiceDate } from '@iotv/datamodel-core';
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import { Alert, Button, Stack } from '@mui/material';
import '@videojs/react/video/skin.css';
import React, { useContext, useEffect, useMemo } from 'react';
import { KinesisVideoStreamContext } from '../../Context/KinesisVideoStreamContext';
import { useHLSFragments } from '../useHLSFramemt';
/** a wrapper component which accepts and IoTV video player implementation with React_HLS_PlayerProps as input   */
export const AWS_KVS_Player = ({ playerEventFns, PlayerComponent }) => {
    const { state, dispatch } = useContext(KinesisVideoStreamContext);
    const { fromTimestamp, toTimestamp, HLSListFragmentsURL, HLSStreamingSessionURL, selectedHLSPlaybackMode, selectedHLSFragmentSelectorType, selectedStreamInfo, DataEndpoint } = state;
    const { getStreamUrl } = useHLSFragments({});
    const onError = (e) => {
        console.log(`onError error`, e.target?.error ?? e);
        const { code, message } = e.target?.error ?? {};
        if (isNonNaNNumber(code) && message) {
            console.error(`onError error code ${code} message ${message} url ${HLSStreamingSessionURL}`);
            getStreamUrl();
        }
        playerEventFns?.onError?.(e);
    };
    const onStalled = (e) => {
        console.log(`onStalled error`, (e.target));
        const { code, message } = e.target?.error ?? {};
        if (isNonNaNNumber(code) && message) {
            console.error(`onStalled error code ${code} message ${message} url ${HLSStreamingSessionURL} NO CURRENT ACTION`);
        }
        playerEventFns?.onStalled?.(e);
    };
    useEffect(() => {
        const shouldFetch = selectedHLSPlaybackMode === HLSPlaybackMode.LIVE || (Boolean(fromTimestamp) && Boolean(toTimestamp));
        if (shouldFetch) {
            console.log(`HLS request inputs changed, refreshing url\n: ${selectedStreamInfo?.StreamName}, ${isNonNaNNumber(fromTimestamp) && isNonNaNNumber(toTimestamp) ? `fromTimestamp: ${getNiceDate(fromTimestamp)}, toTimestamp: ${getNiceDate(toTimestamp)}` : 'no timestamp range'}`);
            getStreamUrl();
        }
        else {
            console.log(`HLS request skipped: missing required timestamp range for non-live playback`);
        }
        // can't clean up here
    }, [selectedHLSPlaybackMode, selectedHLSFragmentSelectorType, fromTimestamp, toTimestamp, selectedStreamInfo, DataEndpoint]);
    const playerComponent = useMemo(() => {
        return HLSListFragmentsURL ? _jsx(PlayerComponent, { url: HLSListFragmentsURL, ...playerEventFns, onStalled, onError }) : null;
    }, [HLSListFragmentsURL, playerEventFns, onStalled, onError]);
    return (_jsxs(Stack, { direction: 'column', spacing: 2, alignItems: 'flex-start', width: '100%', children: [HLSListFragmentsURL ? (_jsx(Stack, { direction: "row", spacing: 2, sx: { width: '100%' }, children: playerComponent })) : (_jsx(Stack, { direction: "row", spacing: 2, sx: { width: '100%' }, children: _jsx(Alert, { severity: "warning", sx: { width: '100%' }, children: selectedHLSPlaybackMode === HLSPlaybackMode.LIVE ? `Live Video Not Available` :
                        fromTimestamp && toTimestamp ? `Video for time range ${getNiceDate(fromTimestamp)} to ${getNiceDate(toTimestamp)} not available` : `Video not available (No time range selected)` }) })), _jsx(Stack, { direction: "row", spacing: 2, sx: { width: '100%' }, children: _jsx(Button, { variant: "contained", color: "primary", onClick: () => getStreamUrl(), children: "Reload Stream" }) })] }));
};
